// 시공반장 일정확인 발송 오류 → 안내 문구. 내부 식별자(historyId 등)는 노출하지 않는다.
import { ForemanConfirmSendError } from '../api/scheduleApi'
import { ForemanChangeError } from '../api/foremanApi'

export const FOREMAN_SEND_MESSAGE = {
  contactMissing: '연락처가 없어 보내지 못했어요 · 시공파트너 정보에서 연락처를 확인해 주세요',
  sendFailed:     '발송에 실패했어요 · 다시 시도해 주세요',
  resendLimit:    '이 반장님께는 이미 한 번 다시 보냈어요',
  conflict:       '다른 곳에서 발송 중이에요',
  notAssigned:    '시공반장이 지정되지 않았어요',
  notAllowed:     '지금 상태에서는 보낼 수 없어요',
  unknown:        '발송에 실패했어요 · 다시 시도해 주세요',
} as const

export function foremanSendErrorMessage(err: unknown): string {
  const code = err instanceof ForemanConfirmSendError ? err.code : 'UNKNOWN'
  switch (code) {
    case 'FOREMAN_CONTACT_MISSING':     return FOREMAN_SEND_MESSAGE.contactMissing
    case 'FOREMAN_CONFIRM_SEND_FAILED': return FOREMAN_SEND_MESSAGE.sendFailed
    case 'RESEND_LIMIT_EXCEEDED':       return FOREMAN_SEND_MESSAGE.resendLimit
    case 'CONFLICT':                    return FOREMAN_SEND_MESSAGE.conflict
    case 'FOREMAN_NOT_ASSIGNED':        return FOREMAN_SEND_MESSAGE.notAssigned
    case 'SEND_NOT_ALLOWED':            return FOREMAN_SEND_MESSAGE.notAllowed
    default:                            return FOREMAN_SEND_MESSAGE.unknown
  }
}

// 확정 반장 변경·반장 해제 오류 → 안내 문구. 연락처 없음·발송 실패는 위 발송 문구를 재사용한다.
export const FOREMAN_CHANGE_MESSAGE = {
  reasonInvalid:  '변경 사유를 골라 주세요',
  notAllowed:     '확정된 반장만 이 방법으로 바꿀 수 있어요',
  samePartner:    '현재 반장과 같아요',
  partnerInvalid: '이 시공파트너는 선택할 수 없어요',
  conflict:       '다른 곳에서 처리 중이에요',
  releaseDenied:  '확정된 반장은 다른 반장으로 바꿔 주세요',
  unknown:        '처리에 실패했어요 · 다시 시도해 주세요',
} as const

export function foremanChangeErrorMessage(err: unknown): string {
  const code = err instanceof ForemanChangeError ? err.code : 'UNKNOWN'
  switch (code) {
    case 'FOREMAN_CHANGE_REASON_INVALID':        return FOREMAN_CHANGE_MESSAGE.reasonInvalid
    case 'FOREMAN_CHANGE_NOT_ALLOWED':           return FOREMAN_CHANGE_MESSAGE.notAllowed
    case 'FOREMAN_CHANGE_SAME_PARTNER':          return FOREMAN_CHANGE_MESSAGE.samePartner
    case 'FOREMAN_CHANGE_PARTNER_INVALID':       return FOREMAN_CHANGE_MESSAGE.partnerInvalid
    case 'FOREMAN_CONTACT_MISSING':              return FOREMAN_SEND_MESSAGE.contactMissing
    case 'FOREMAN_CONFIRM_SEND_FAILED':          return FOREMAN_SEND_MESSAGE.sendFailed
    case 'CONFIRMED_FOREMAN_RELEASE_NOT_ALLOWED': return FOREMAN_CHANGE_MESSAGE.releaseDenied
    case 'CONFLICT':                             return FOREMAN_CHANGE_MESSAGE.conflict
    default:                                     return FOREMAN_CHANGE_MESSAGE.unknown
  }
}

// ── 일정 변경 카톡(건별 failReason) → 안내 문구. 내부 id 노출 금지 ──
export function scheduleChangeNoticeFailMessage(failReason: string | null | undefined): string {
  switch (failReason) {
    case 'NO_CONTACT':       return '연락처가 없어 보내지 못했어요'
    case 'SEND_FAILED':      return '발송에 실패했어요'
    case 'NOT_NOTIFIABLE':   return '지금 상태에서는 보낼 수 없어요'
    case 'CONFLICT':         return '다른 곳에서 발송 중이에요'
    default:                 return '보내지 못했어요'
  }
}
